import React, { useState, useEffect } from "react"
import PlanVariantSwitch from "app/shared/components/plan-variant-switch"
import { StripeForm } from "app/shared/components/card-form/stripe-form"
import { Elements } from "@stripe/react-stripe-js"
import { useStripe } from "hooks/use-stripe"
import usePromoCode from "hooks/use-promo-code"

import Note from "@kit/design/note"

import { BillingNotice } from "./billing-notice"

const noop = () => {}

const Discount = ({ promoCode }) => {
  const { removePromoCode } = usePromoCode()

  if (promoCode.valid) {
    return (
      <Note
        type="success"
        title="Discount applied!"
        message={promoCode.message}
        className="mb-8"
      />
    )
  } else {
    return (
      <Note
        type="error"
        title={`${promoCode.redemption_code} cannot be applied`}
        message={promoCode.message}
        className="mb-8"
        action={{
          label: "Dismiss",
          onClick: removePromoCode
        }}
      />
    )
  }
}

export function Content({
  handleSubscription,
  stripeData,
  currentPlans,
  trialPeriodEnd,
  trialing,
  billingCycle,
  currentlyOnFreePlan,
  onPlanChange = noop,
  modalOptions,
  options
}) {
  const prioritizedPlan = currentPlans.find(plan => plan.prioritize_plan)
  const [activePlan, setActivePlan] = useState(
    prioritizedPlan?.id ||
      currentPlans.find(plan => plan.interval === billingCycle)?.id
  )

  const activeCurrentPlan = currentPlans.find(plan => plan.id === activePlan)

  const [stripeOptions, setStripeOptions] = useState(stripeData.options)

  const { removePromoCode } = usePromoCode()

  useEffect(() => {
    const newOptions = stripeOptions

    if (activeCurrentPlan.promo_code?.valid) {
      newOptions.promo_code = activeCurrentPlan.promo_code.redemption_code
    } else {
      newOptions.promo_code = null
    }

    setStripeOptions(newOptions)
  }, [activePlan])

  const handlePlanChange = planId => {
    setActivePlan(planId)
    onPlanChange(planId)
  }

  const successCallback = async () => {
    removePromoCode()

    if (handleSubscription != undefined) {
      handleSubscription()
    }
  }

  const stripe = useStripe(stripeData.stripe_key)

  return (
    <div>
      {activeCurrentPlan.promo_code && (
        <Discount promoCode={activeCurrentPlan.promo_code} />
      )}

      <div className="mb-10">
        <PlanVariantSwitch
          handlePlanChange={handlePlanChange}
          activePlanId={activePlan}
          availablePlans={currentPlans}
        />
      </div>

      <div>
        <Elements stripe={stripe}>
          <StripeForm
            options={stripeOptions}
            planId={activePlan}
            successCallback={successCallback}
            modalOptions={modalOptions}
            buttonText={options?.buttonText}
            config={{
              useTooltipForDisabled: options?.buttonUsesTooltipForDisabled
            }}
          />
        </Elements>
      </div>

      <div className="mt-10">
        <BillingNotice
          plan={activeCurrentPlan}
          trialing={trialing}
          trialPeriodEnd={trialPeriodEnd}
          currentlyOnFreePlan={currentlyOnFreePlan}
          showSubscriberCount={options?.showSubscriberCountInNotice}
        />
      </div>
    </div>
  )
}
